(function () {
  var IMAGE_BASE = 'https://cdn.shopify.com/s/files/1/0348/6482/4451/files/';
  var PRODUCT_IMAGE_BASE = 'https://www.mysheepi.com/cdn/shop/files/';

  var IMAGE_MAP = {
    homePillow: PRODUCT_IMAGE_BASE + 'mysheepi-home-kissen-introbild-beige_92a91c58-536e-4332-a33a-ac41dba953e7.png?v=1767608579&width=250',
    homeDuvet: IMAGE_BASE + 'mysheepi-home-bettdecke-introbild-beige.png?v=1776938422&width=250',
    homeProPillow: IMAGE_BASE + 'mysheepi-home-pro-kopfkissen.png?v=1766996750&width=250',
    homeProDuvet: IMAGE_BASE + 'mysheepi-home-pro-bettdecke.png?v=1766996770&width=250',
    seatCushion: IMAGE_BASE + 'mysheepi-ergonomisches-sitzkissen-introbild-beige.png?v=1766997062&width=250',
    seatCushionCover: IMAGE_BASE + 'mysheepi-ergonomisches-rueckenstuetzkissen-introbild-beige.png?v=1766997178&width=250',
    beddingSet: IMAGE_BASE + 'HOME_Premium_Bettwasche_Set.png?v=1779273272&width=250',
    beddingDuvetCover: IMAGE_BASE + 'HOME_Premium_Bettdeckenbezug_-_Introbild2.png?v=1767183173&width=250',
    beddingPillowCase: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-beige.jpg?v=1766997379&width=250',
    beddingPillowColor: {
      beige: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-beige.jpg?v=1766997379&width=250',
      grau: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-grau.jpg?v=1766997379&width=250',
      weiss: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-wei.jpg?v=1766997379&width=250'
    },
    beddingColor: {
      beige: IMAGE_BASE + 'HOME_Premium_Bettdeckenbezug_beige_99d3a6b5-235f-4696-9685-2df4f554d0b4.png?v=1767614121&width=250',
      grau: IMAGE_BASE + 'image_c58c3cb7-700f-421a-994b-a680a36005d8.png?v=1767614611&width=250',
      weiss: IMAGE_BASE + 'HOME_Premium_Bettdeckenbezug_white_32aa20d2-ee72-4731-80b8-52ae772be9a1.png?v=1767614121&width=250'
    },
    travelSet: IMAGE_BASE + 'HOME_Reisekissen_Set_409e147d-45ef-4f34-94db-03b43b24f394.jpg?v=1769773855&width=250',
    travelPillow: IMAGE_BASE + 'mysheepi-travel-reisekissen-introbild-beige.png?v=1766997351&width=250',
    travelCover: {
      beige: IMAGE_BASE + 'TRAVEL-kissenbezug-luxus-baumwolle-beige.png?v=1766997331&width=250',
      grau: IMAGE_BASE + 'TRAVEL-kissenbezug-luxus-baumwolle-grau_144a80fc-7e04-46b8-9fdb-b4c2376b434c.png?v=1766997331&width=250',
      blau: IMAGE_BASE + 'TRAVEL-kissenbezug-luxus-baumwolle-blau_56272bde-24fb-43a8-a7dd-c8b7d8afb4e4.png?v=1766997331&width=250',
      marineblau: IMAGE_BASE + 'TRAVEL_Premium_Kissenbezug_Marineblau.png?v=1771266223&width=250',
      rot: IMAGE_BASE + 'TRAVEL-kissenbezug-luxus-baumwolle-Rot_32fb5b40-6cbe-4873-ab21-289e7818f42e.png?v=1766997331&width=250'
    },
    silkPillowCase: IMAGE_BASE + 'mysheepi-homoe-seidenkissenbezug-introbild-beige_b9f070be-c6fc-43ea-a15a-9b9ed979f301.png?v=1767009760&width=250',
    silkMaskDefault: IMAGE_BASE + 'mysheepi-seidenschlafmaske-introbild-beige_992d42a3-e955-415a-824f-920aa123babc.png?v=1766997103&width=250',
    cover: {
      beige: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-beige.jpg?v=1766997379&width=250',
      grau: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-grau.jpg?v=1766997379&width=250',
      marineblau: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-blau.jpg?v=1766997379&width=250',
      blau: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-blau.jpg?v=1766997379&width=250',
      rot: IMAGE_BASE + 'Pillow_case_bordeaux.png?v=1766997379&width=250',
      weiss: IMAGE_BASE + 'HOME-luxus-kissenbezug-baumwolle-wei.jpg?v=1766997379&width=250'
    },
    bedding: {
      beige: IMAGE_BASE + 'HOME_Premium_Bettwasche_Set.png?v=1779273272&width=250',
      grau: IMAGE_BASE + 'mysheepi-bettwaesche-baumwolle-oeko-tex.png?v=1776692903&width=250',
      weiss: IMAGE_BASE + 'mysheepi-home-aegyptische-baumwolle-bettwaesche-set-weiss-produktbild-3.png?v=1776692903&width=250'
    },
    spray: {
      default: IMAGE_BASE + 'Spray3.png?v=1766997525&width=250',
      'rose-zitrone': IMAGE_BASE + 'Rose_und_Zitrone.png?v=1766997525&width=250',
      'eukalyptus-zitrone': IMAGE_BASE + 'Enkalyptus_unf_Zitrone.png?v=1766997525&width=250',
      zirbe: IMAGE_BASE + 'Zirbenholz_a5ad34b7-f56c-4753-8626-d47965c27bdb.png?v=1766997525&width=250',
      lavendel: IMAGE_BASE + 'Lavendel.png?v=1766997525&width=250',
      'orange-zitrone': IMAGE_BASE + 'kissenspray-zitrone-orange-beiger-hintergrund.png?v=1766997525&width=250'
    },
    silkPillow: {
      elfenbein: IMAGE_BASE + 'mysheepi-homoe-seidenkissenbezug-introbild-beige_b9f070be-c6fc-43ea-a15a-9b9ed979f301.png?v=1767009760&width=250',
      grau: IMAGE_BASE + 'grey_bag.jpg?v=1766997465&width=250',
      hellrosa: IMAGE_BASE + 'Hell_Rosa_c14416ba-813c-48cb-90cd-e4a8fd7d1d88.png?v=1766997465&width=250',
      marineblau: IMAGE_BASE + 'mysheepi-HOME-Seidenkissenbezug-Marineblau.png?v=1766997465&width=250',
      pistazie: IMAGE_BASE + 'mint_bag.jpg?v=1766997465&width=250',
      rosa: IMAGE_BASE + 'pink_bag.jpg?v=1766997465&width=250',
      flieder: IMAGE_BASE + 'purple_pillow_with_badge.jpg?v=1766997465&width=250'
    },
    silkMask: {
      elfenbein: IMAGE_BASE + 'mysheepi-seidenschlafmaske-introbild-beige_992d42a3-e955-415a-824f-920aa123babc.png?v=1766997103&width=250',
      grau: IMAGE_BASE + 'mysheepi-seidenschlafmaske-introbild-Grau_d58d7e79-3053-4446-aa4a-8200631350a9.png?v=1766997103&width=250',
      hellrosa: IMAGE_BASE + 'mysheepi-seidenschlafmaske-introbild-HellRosa_eec54585-e940-448b-aa5e-686f16e9524c.png?v=1766997103&width=250',
      marineblau: IMAGE_BASE + 'mysheepi-seidenschlafmaske-introbild-Navy_09d79f7f-cf3f-4100-87b4-6648a0913fd2.png?v=1766997103&width=250'
    }
  };

  var ROW_ORDER = [
    'home-pillow',
    'home-pro-pillow',
    'home-duvet',
    'home-pro-duvet',
    'seat-cushion',
    'seat-cushion-cover',
    'travel-pillow',
    'travel-cover',
    'bedding-pillowcase',
    'bedding-duvet-cover',
    'fitted-sheet',
    'bedding-color',
    'cotton-cover',
    'silk-pillowcase',
    'silk-mask',
    'spray',
    'color',
    'size',
    'generic'
  ];

  var HIDDEN_OPTIONS = {
    'cotton-cover': ['blau'],
    'travel-cover': ['blau'],
    spray: ['orange-zitrone']
  };

  var SUBTITLES = {
    'home-pillow': 'Ergonomisch & 100% anpassbar an Deine Schlafposition',
    'home-pro-pillow': 'Kühlender Komfort mit ergonomischer Nackenstütze',
    'home-duvet': 'Ganzjahresbettdecke für ausgeglichenen Schlafkomfort',
    'home-pro-duvet': 'Kühlende Bettdecke für frisches Schlafklima',
    'seat-cushion': 'Entlastet Becken und Steißbein',
    'seat-cushion-cover': 'Unterstützt eine Sitzhaltung',
    'travel-pillow': 'Kompakter Komfort für unterwegs',
    'travel-cover': 'Atmungsaktiv aus hochwertiger ägyptischer Baumwolle',
    'bedding-pillowcase': 'Weich, atmungsaktiv und maßgeschneidert für Dein mySheepi',
    'bedding-duvet-cover': 'Atmungsaktiv aus hochwertiger ägyptischer Baumwolle',
    'fitted-sheet': 'Ägyptische Baumwolle mit extra hoher Seitenlänge von 30 cm',
    'bedding-color': 'Wähle die gemeinsame Farbe für Kissenbezug und Bettdeckenbezug',
    'cotton-cover': 'Weich, atmungsaktiv und maßgeschneidert für Dein mySheepi',
    'silk-pillowcase': 'Hochwertige Seide für strahlende Haut und Haare',
    'silk-mask': 'Anpassbar, weich und 100% Lichtblockierung',
    spray: 'Beruhigender Duft für tiefen Schlaf'
  };

  var PLACEHOLDERS = {
    color: 'Farbe auswählen',
    scent: 'Duft auswählen',
    size: 'Größe auswählen',
    generic: 'Auswählen'
  };

  var SET_HEADING = 'Stelle Dein Spar-Set zusammen';
  var CONTROL_SELECTOR = '.mida-set-select, .mida-set-swatch-group';
  var COLOR_SWATCHES = {
    beige: '#d7c6a3',
    grau: '#737b86',
    weiss: '#ffffff'
  };

  function cleanText(el) {
    if (!el) return '';

    var clone = el.cloneNode(true);
    clone.querySelectorAll('.label-unavailable, .visually-hidden').forEach(function (hidden) {
      hidden.remove();
    });

    return clone.textContent.replace(/\s+/g, ' ').replace(/:$/, '').trim();
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/weiß/g, 'weiss')
      .replace(/[()]/g, '')
      .replace(/\s+/g, '-')
      .trim();
  }

  function getColorKey(value) {
    return normalize(value)
      .replace(/-set$/g, '')
      .replace(/-standard.*$/g, '')
      .replace(/-kompakt.*$/g, '')
      .trim();
  }

  function isSetProduct(variantSelects) {
    var product = getProductMeta(variantSelects);
    var handle = product.handle || getHandleFromUrl(product.url);
    var title = product.title || '';
    return normalize(handle).indexOf('set') !== -1 || normalize(title).indexOf('set') !== -1;
  }

  function getProductMeta(variantSelects) {
    var globalProduct = window.midaSetProduct || {};

    if (!variantSelects) {
      return {
        handle: globalProduct.handle || '',
        title: globalProduct.title || '',
        featuredImage: globalProduct.featuredImage || '',
        url: ''
      };
    }

    return {
      handle: variantSelects.dataset.productHandle || globalProduct.handle || '',
      title: variantSelects.dataset.productTitle || globalProduct.title || '',
      featuredImage: variantSelects.dataset.productFeaturedImage || globalProduct.featuredImage || '',
      url: variantSelects.dataset.url || ''
    };
  }

  function getHandleFromUrl(url) {
    return String(url || '').split('/').filter(Boolean).pop() || '';
  }

  function getScope(variantSelects) {
    if (!variantSelects) return document;

    return (
      variantSelects.closest('product-info') ||
      variantSelects.closest('.product__info-container') ||
      variantSelects.closest('section') ||
      document
    );
  }

  function getBuyWrapper(variantSelects) {
    var scope = getScope(variantSelects);
    return (
      scope.querySelector('.buy-button__wrapper') ||
      document.querySelector('.buy-button__wrapper')
    );
  }

  function getOptionName(fieldset) {
    var input = fieldset.querySelector('input[type="radio"]');
    return input && input.name ? input.name : cleanText(fieldset.querySelector('legend'));
  }

  function getOptionKind(optionName) {
    var text = normalize(optionName);

    if (text.indexOf('duft') !== -1 || text.indexOf('spray') !== -1) return 'scent';
    if (text.indexOf('farbe') !== -1 || text.indexOf('color') !== -1 || text.indexOf('colour') !== -1) return 'color';
    if (text.indexOf('groesse') !== -1 || text.indexOf('größe') !== -1 || text.indexOf('size') !== -1) return 'size';

    return 'generic';
  }

  function getRowKey(optionName, productHandle) {
    var text = normalize(optionName);
    var handle = normalize(productHandle);

    if (text.indexOf('kissenspray') !== -1 || text.indexOf('duft') !== -1) return 'spray';
    if (text.indexOf('seidenschlafmaske') !== -1 || text.indexOf('seidenmaske') !== -1 || text.indexOf('maske') !== -1) return 'silk-mask';
    if (text.indexOf('seidenkissenbezug') !== -1) return 'silk-pillowcase';
    if (text.indexOf('bettdeckenbezug') !== -1) return 'bedding-duvet-cover';
    if (text.indexOf('spannbettlaken') !== -1) return 'fitted-sheet';
    if (text.indexOf('sitzkissen') !== -1 && text.indexOf('bezug') !== -1) return 'seat-cushion-cover';
    if (text.indexOf('sitzkissen') !== -1) return 'seat-cushion';
    if (text.indexOf('kissenbezug') !== -1 && handle.indexOf('travel') !== -1) return 'travel-cover';
    if (text.indexOf('kissenbezug') !== -1 && handle.indexOf('bettwaesche') !== -1) return 'bedding-pillowcase';
    if (text.indexOf('kissenbezug') !== -1 || text.indexOf('premium-kissenbezug') !== -1) return 'cotton-cover';
    if (getOptionKind(optionName) === 'color' && handle.indexOf('bettwaesche') !== -1) return 'bedding-color';
    if (text.indexOf('pro-bettdecke') !== -1) return 'home-pro-duvet';
    if (text.indexOf('bettdecke') !== -1) return 'home-duvet';
    if (text.indexOf('pro-kopfkissen') !== -1) return 'home-pro-pillow';
    if (text.indexOf('reisekissen') !== -1) return 'travel-pillow';
    if (text.indexOf('kopfkissen') !== -1 || text.indexOf('nackenkissen') !== -1) return 'home-pillow';
    if (getOptionKind(optionName) === 'color') return 'color';
    if (getOptionKind(optionName) === 'size') return 'size';

    return 'generic';
  }

  function getRowSortValue(row) {
    var index = ROW_ORDER.indexOf(row.key);
    return index === -1 ? ROW_ORDER.length : index;
  }

  function stripOptionHint(text) {
    return String(text || '').replace(/\s*\((Farbe|Duft|Größe|Groesse|Size|Color|Colour)\)\s*$/i, '').trim();
  }

  function getPlaceholder(kind) {
    return PLACEHOLDERS[kind] || PLACEHOLDERS.generic;
  }

  function getGenericImage(rowKey, productHandle, fallbackImage) {
    var handle = normalize(productHandle);

    if (rowKey === 'home-pillow') return IMAGE_MAP.homePillow;
    if (rowKey === 'home-pro-pillow') return IMAGE_MAP.homeProPillow;
    if (rowKey === 'home-duvet') return IMAGE_MAP.homeDuvet;
    if (rowKey === 'home-pro-duvet') return IMAGE_MAP.homeProDuvet;
    if (rowKey === 'seat-cushion') return IMAGE_MAP.seatCushion;
    if (rowKey === 'seat-cushion-cover') return IMAGE_MAP.seatCushionCover;
    if (rowKey === 'travel-pillow') return IMAGE_MAP.travelPillow;
    if (rowKey === 'travel-cover') return IMAGE_MAP.travelCover.grau;
    if (rowKey === 'bedding-pillowcase') return IMAGE_MAP.beddingPillowCase;
    if (rowKey === 'bedding-duvet-cover') return IMAGE_MAP.beddingDuvetCover;
    if (rowKey === 'bedding-color') return IMAGE_MAP.beddingSet;
    if (rowKey === 'cotton-cover') return IMAGE_MAP.cover.beige;
    if (rowKey === 'silk-pillowcase') return IMAGE_MAP.silkPillowCase;
    if (rowKey === 'silk-mask') return IMAGE_MAP.silkMaskDefault;
    if (rowKey === 'spray') return IMAGE_MAP.spray.default;
    if (handle.indexOf('bettwaesche') !== -1) return IMAGE_MAP.beddingSet;
    if (handle.indexOf('travel') !== -1) return IMAGE_MAP.travelSet;

    return fallbackImage || IMAGE_MAP.homePillow;
  }

  function getSelectedImage(rowKey, productHandle, value, fallbackImage) {
    var key = getColorKey(value);
    var handle = normalize(productHandle);

    if (rowKey === 'cotton-cover') return IMAGE_MAP.cover[key] || IMAGE_MAP.cover.beige;
    if (rowKey === 'travel-cover') return IMAGE_MAP.travelCover[key] || IMAGE_MAP.travelCover.grau;
    if (rowKey === 'spray') return IMAGE_MAP.spray[key] || IMAGE_MAP.spray.default;
    if (rowKey === 'silk-pillowcase') return IMAGE_MAP.silkPillow[key] || IMAGE_MAP.silkPillowCase;
    if (rowKey === 'silk-mask') return IMAGE_MAP.silkMask[key] || IMAGE_MAP.silkMaskDefault;
    if (rowKey === 'bedding-pillowcase') return IMAGE_MAP.beddingPillowColor[key] || IMAGE_MAP.beddingPillowCase;
    if (rowKey === 'bedding-duvet-cover') return IMAGE_MAP.beddingColor[key] || IMAGE_MAP.beddingDuvetCover;
    if (rowKey === 'bedding-color') return IMAGE_MAP.beddingColor[key] || IMAGE_MAP.beddingSet;
    if (rowKey === 'color' && handle.indexOf('bettwaesche') !== -1) return IMAGE_MAP.beddingColor[key] || IMAGE_MAP.beddingSet;

    return fallbackImage;
  }

  function getSwatchColor(value) {
    var key = getColorKey(value);
    return COLOR_SWATCHES[key] || '#d7c6a3';
  }

  function updateBeddingSharedImages(builder, value) {
    var pillowRow = builder.querySelector('.mida-set-row[data-row="bedding-pillowcase"]');
    var duvetRow = builder.querySelector('.mida-set-row[data-row="bedding-duvet-cover"]');

    if (pillowRow) {
      setRowImage(pillowRow, getSelectedImage('bedding-pillowcase', 'bettwaesche-set-baumwolle', value, IMAGE_MAP.beddingPillowCase));
    }

    if (duvetRow) {
      setRowImage(duvetRow, getSelectedImage('bedding-duvet-cover', 'bettwaesche-set-baumwolle', value, IMAGE_MAP.beddingDuvetCover));
    }
  }

  function isHiddenOption(type, value) {
    var hidden = HIDDEN_OPTIONS[type] || [];
    return hidden.indexOf(normalize(value)) !== -1;
  }

  function escapeSelector(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value || '').replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function getState(variantSelects) {
    if (!variantSelects) {
      return {
        variantData: [],
        optionNameToIndex: {}
      };
    }

    if (variantSelects.midaSetBuilderState) return variantSelects.midaSetBuilderState;

    var json = variantSelects.querySelector('script[type="application/json"]');
    var state = {
      variantData: [],
      optionNameToIndex: {}
    };

    if (json) {
      try {
        state.variantData = JSON.parse(json.textContent) || [];
      } catch (e) {
        state.variantData = [];
      }
    }

    Array.from(variantSelects.querySelectorAll('fieldset.product-form__input')).forEach(function (fieldset, index) {
      var optionName = getOptionName(fieldset);
      if (optionName) state.optionNameToIndex[optionName] = index;
    });

    variantSelects.midaSetBuilderState = state;
    return state;
  }

  function setRowImage(row, src) {
    if (!row) return;
    var img = row.querySelector('.mida-set-img img');
    if (img && src) img.src = src;
  }

  function setRowError(row, hasError) {
    if (row && row.classList.contains('mida-set-row--swatches')) {
      var title = row.querySelector('.mida-set-title');
      var bodyError = row.querySelector('.mida-set-body > .mida-set-error');
      if (title && bodyError && !title.contains(bodyError)) title.appendChild(bodyError);
    }

    var error = row.querySelector('.mida-set-error');
    var triggers = Array.from(row.querySelectorAll(CONTROL_SELECTOR));

    row.classList.toggle('mida-set-row--error', hasError);
    triggers.forEach(function (trigger) {
      var triggerHasError = hasError && trigger.dataset.midaUserPicked !== 'true';
      if (trigger.classList.contains('mida-set-swatch-group')) {
        trigger.classList.toggle('mida-set-swatch-group--error', triggerHasError);
      } else {
        trigger.classList.toggle('mida-set-select--error', triggerHasError);
      }
    });
    if (error) error.hidden = !hasError;
  }

  function clearAllErrors(builder) {
    builder.querySelectorAll('.mida-set-row').forEach(function (row) {
      setRowError(row, false);
    });
  }

  function getPickedValues(builder, excludeOptionName) {
    var picked = {};

    builder.querySelectorAll(CONTROL_SELECTOR).forEach(function (trigger) {
      if (trigger.dataset.midaUserPicked !== 'true') return;
      if (!trigger.dataset.optionName || trigger.dataset.optionName === excludeOptionName) return;

      picked[trigger.dataset.optionName] = trigger.dataset.value;
    });

    return picked;
  }

  function variantMatchesOption(variant, optionName, value, picked, state) {
    var optionIndex = state.optionNameToIndex[optionName];
    if (optionIndex == null) return true;

    var variantOptions = variant.options || [variant.option1, variant.option2, variant.option3];

    if (variantOptions[optionIndex] !== value) return false;

    return Object.keys(picked).every(function (pickedName) {
      var pickedIndex = state.optionNameToIndex[pickedName];
      return pickedIndex == null || variantOptions[pickedIndex] === picked[pickedName];
    });
  }

  function getOptionStatus(builder, optionName, value) {
    if (builder.midaComponentSet) return getComponentOptionStatus(builder, optionName, value);

    var variantSelects = document.getElementById(builder.dataset.variantSelectsId);
    var state = variantSelects ? getState(variantSelects) : null;
    if (!state || !state.variantData.length) return 'available';

    var picked = getPickedValues(builder, optionName);
    var matches = state.variantData.filter(function (variant) {
      return variantMatchesOption(variant, optionName, value, picked, state);
    });

    if (!matches.length) return 'unavailable';

    var hasAvailableVariant = matches.some(function (variant) {
      return variant.available === true;
    });

    return hasAvailableVariant ? 'available' : 'soldout';
  }

  function updateDropdownAvailability(builder) {
    builder.querySelectorAll('.mida-set-menu__item').forEach(function (item) {
      var status = getOptionStatus(builder, item.dataset.optionName, item.dataset.value);
      var label = item.dataset.label || item.textContent.trim();

      item.hidden = status === 'unavailable';
      item.classList.toggle('is-sold-out', status === 'soldout');
      item.setAttribute('aria-disabled', 'false');
      item.setAttribute('aria-label', status === 'soldout' ? label + ' Ausverkauft' : label);
      item.title = status === 'soldout' ? 'Ausverkauft' : '';
    });

    builder.querySelectorAll('.mida-set-swatch').forEach(function (item) {
      var status = getOptionStatus(builder, item.dataset.optionName, item.dataset.value);
      var label = item.dataset.label || item.textContent.trim();

      item.hidden = false;
      item.classList.toggle('is-sold-out', status !== 'available');
      item.setAttribute('aria-disabled', 'false');
      item.setAttribute('aria-label', status !== 'available' ? label + ' Ausverkauft' : label);
      item.title = status !== 'available' ? 'Ausverkauft' : '';
    });

    applySetBlockedState(builder);
    if (builder.midaComponentSet) syncComponentSet(builder);
  }

  function isOptionIntrinsicallySoldOut(builder, optionName) {
    if (builder.midaComponentSet) return isComponentOptionSoldOut(builder, optionName);

    var variantSelects = document.getElementById(builder.dataset.variantSelectsId);
    var state = variantSelects ? getState(variantSelects) : null;
    if (!state || !state.variantData.length) return false;

    var optionIndex = state.optionNameToIndex[optionName];
    if (optionIndex == null) return false;

    var values = [];
    state.variantData.forEach(function (variant) {
      var opts = variant.options || [variant.option1, variant.option2, variant.option3];
      var val = opts[optionIndex];
      if (val && values.indexOf(val) === -1) values.push(val);
    });

    if (!values.length) return false;

    return values.every(function (value) {
      var matches = state.variantData.filter(function (variant) {
        var opts = variant.options || [variant.option1, variant.option2, variant.option3];
        return opts[optionIndex] === value;
      });
      return matches.length > 0 && matches.every(function (variant) {
        return variant.available === false;
      });
    });
  }

  function applySetBlockedState(builder) {
    var soldOutOptions = [];
    var rowSoldOut = (/** @type {any} */ (window)).midaRowSoldOut || null;

    builder.querySelectorAll('.mida-set-dropdown').forEach(function (dropdown) {
      var trigger = dropdown.querySelector('.mida-set-select');
      if (!trigger || !trigger.dataset.optionName) return;

      var rowKey = trigger.dataset.rowKey;
      var optionName = trigger.dataset.optionName;
      var isSoldOut = false;

      if (rowSoldOut !== null && Object.prototype.hasOwnProperty.call(rowSoldOut, rowKey)) {
        // Component product data: available=false means sold out
        isSoldOut = rowSoldOut[rowKey] === false;
      } else {
        // No component data for this row: fall back to variant-based check
        isSoldOut = isOptionIntrinsicallySoldOut(builder, optionName);
      }

      if (isSoldOut) soldOutOptions.push(optionName);
    });

    var setIsBlocked = soldOutOptions.length > 0;

    builder.querySelectorAll('.mida-set-select').forEach(function (trigger) {
      var label = trigger.querySelector('.mida-set-select__label');
      var placeholder = trigger.dataset.placeholder || '';
      var isSoldOutItem = soldOutOptions.indexOf(trigger.dataset.optionName) !== -1;

      trigger.disabled = setIsBlocked;

      if (setIsBlocked && isSoldOutItem) {
        var soldOutText = placeholder + ' (Ausverkauft)';
        if (label && label.textContent !== soldOutText) label.textContent = soldOutText;
      } else if (!setIsBlocked && label && trigger.dataset.midaUserPicked !== 'true') {
        if (label.textContent !== placeholder) label.textContent = placeholder;
      }
    });

    builder.querySelectorAll('.mida-set-swatch').forEach(function (swatch) {
      swatch.disabled = setIsBlocked;
    });
  }

  function validateSelections(builder, showErrors) {
    if (!builder) return true;

    var isValid = true;

    builder.querySelectorAll('.mida-set-row').forEach(function (row) {
      var triggers = Array.from(row.querySelectorAll(CONTROL_SELECTOR));
      var userPicked = !triggers.length || triggers.every(function (trigger) {
        return trigger.dataset.midaUserPicked === 'true';
      });

      if (!userPicked) isValid = false;
      if (showErrors) setRowError(row, !userPicked);
    });

    return isValid;
  }

  function rowSelectionsComplete(row) {
    return Array.from(row.querySelectorAll(CONTROL_SELECTOR)).every(function (trigger) {
      return trigger.dataset.midaUserPicked === 'true';
    });
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('.mida-set-dropdown.is-open').forEach(function (dd) {
      if (dd !== except) {
        dd.classList.remove('is-open');
        var trig = dd.querySelector('.mida-set-select');
        if (trig) trig.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function getOptionIndex(builder, optionName) {
    var variantSelects = document.getElementById(builder.dataset.variantSelectsId);
    var state = variantSelects ? getState(variantSelects) : null;

    if (!state || !optionName) return null;
    return state.optionNameToIndex[optionName];
  }

  function resetDropdown(trigger) {
    var dropdown = trigger.closest('.mida-set-dropdown');
    var row = trigger.closest('.mida-set-row');
    var label = trigger.querySelector('.mida-set-select__label');

    trigger.dataset.midaUserPicked = 'false';
    delete trigger.dataset.value;
    trigger.classList.remove('mida-set-select--selected', 'mida-set-select--error');

    if (label) label.textContent = trigger.dataset.placeholder || '';

    if (dropdown) {
      dropdown.querySelectorAll('.mida-set-menu__item').forEach(function (item) {
        item.classList.remove('is-active');
      });
    }

    if (row && !row.querySelector('.mida-set-select--selected')) {
      row.classList.remove('mida-set-row--selected', 'mida-set-row--error');
    }

    if (row && trigger.dataset.genericImage && (trigger.dataset.kind === 'color' || trigger.dataset.kind === 'scent')) {
      setRowImage(row, trigger.dataset.genericImage);
    }
  }

  function resetSwatchGroup(group) {
    var row = group.closest('.mida-set-row');

    group.dataset.midaUserPicked = 'false';
    delete group.dataset.value;
    group.classList.remove('mida-set-swatch-group--error');
    group.querySelectorAll('.mida-set-swatch').forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-checked', 'false');
    });

    if (row && !row.querySelector('.mida-set-select--selected, .mida-set-swatch.is-active')) {
      row.classList.remove('mida-set-row--selected', 'mida-set-row--error');
    }

    if (group.dataset.rowKey === 'bedding-color') {
      var builder = group.closest('.mida-set-builder');
      if (builder) {
        setRowImage(
          builder.querySelector('.mida-set-row[data-row="bedding-pillowcase"]'),
          IMAGE_MAP.beddingPillowCase
        );
        setRowImage(
          builder.querySelector('.mida-set-row[data-row="bedding-duvet-cover"]'),
          IMAGE_MAP.beddingDuvetCover
        );
      }
    }
  }

  function resetControl(control) {
    if (control.classList.contains('mida-set-swatch-group')) {
      resetSwatchGroup(control);
      return;
    }

    resetDropdown(control);
  }

  function resetDependentDropdowns(builder, changedOptionName, changedTrigger) {
    if (builder.midaComponentSet) {
      resetSoldOutComponentPicks(builder, changedTrigger);
      return;
    }

    var changedIndex = getOptionIndex(builder, changedOptionName);
    var changedRow = changedTrigger && changedTrigger.closest('.mida-set-row');
    if (changedIndex == null) return;

    builder.querySelectorAll(CONTROL_SELECTOR).forEach(function (trigger) {
      var optionIndex = getOptionIndex(builder, trigger.dataset.optionName);
      if (optionIndex == null || optionIndex <= changedIndex) return;
      if (
        changedRow &&
        trigger.closest('.mida-set-row') !== changedRow &&
        !trigger.closest('.mida-set-row--shared-color')
      ) return;
      if (trigger.dataset.midaUserPicked !== 'true') return;
      if (getOptionStatus(builder, trigger.dataset.optionName, trigger.dataset.value) === 'available') return;
      resetControl(trigger);
    });
  }

  function applyVariantToOriginalPickers(variantSelects, variant) {
    var optionInputs = Array.from(variantSelects.querySelectorAll('select, fieldset'));

    optionInputs.forEach(function (element, index) {
      var optionValue = variant.options && variant.options[index];
      if (!optionValue) return;

      if (element.tagName === 'SELECT') {
        element.value = optionValue;
        return;
      }

      if (element.tagName === 'FIELDSET') {
        var radio = Array.from(element.querySelectorAll('input[type="radio"]')).find(function (input) {
          return input.value === optionValue;
        });

        if (radio) radio.checked = true;
      }
    });
  }

  function reconcileUnderlyingVariant(builder) {
    var variantSelects = document.getElementById(builder.dataset.variantSelectsId);
    var state = variantSelects ? getState(variantSelects) : null;
    if (!variantSelects || !state || !state.variantData.length) return null;

    var picked = getPickedValues(builder);
    var matches = state.variantData.filter(function (variant) {
      var variantOptions = variant.options || [variant.option1, variant.option2, variant.option3];

      return Object.keys(picked).every(function (pickedName) {
        var pickedIndex = state.optionNameToIndex[pickedName];
        return pickedIndex == null || variantOptions[pickedIndex] === picked[pickedName];
      });
    });
    var variant = matches.find(function (item) {
      return item.available === true;
    }) || matches[0];

    if (!variant) return null;
    applyVariantToOriginalPickers(variantSelects, variant);

    return variant;
  }

  function dispatchVariantChange(builder, preferredInput) {
    var variantSelects = document.getElementById(builder.dataset.variantSelectsId);
    if (!variantSelects) return;

    var eventTarget = preferredInput && preferredInput.checked
      ? preferredInput
      : variantSelects.querySelector('input[type="radio"]:checked, select');

    if (!eventTarget) return;
    eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
    eventTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function scheduleInitialVariantSync(builder) {
    if (builder.dataset.midaVariantSyncScheduled === 'true') return;
    builder.dataset.midaVariantSyncScheduled = 'true';

    [0, 120, 280, 620].forEach(function (delay) {
      window.setTimeout(function () {
        reconcileUnderlyingVariant(builder);
        dispatchVariantChange(builder);
      }, delay);
    });
  }

  function makeDropdownFromFieldset(config) {
    var dropdown = document.createElement('div');
    dropdown.className = 'mida-set-dropdown';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mida-set-select';
    trigger.dataset.midaUserPicked = 'false';
    trigger.dataset.optionName = config.optionName;
    trigger.dataset.placeholder = config.placeholder;
    trigger.dataset.rowKey = config.rowKey;
    trigger.dataset.kind = config.kind;
    trigger.dataset.genericImage = config.genericImage || '';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var labelSpan = document.createElement('span');
    labelSpan.className = 'mida-set-select__label';
    labelSpan.textContent = config.placeholder;
    trigger.appendChild(labelSpan);

    var menu = document.createElement('ul');
    menu.className = 'mida-set-menu';
    menu.setAttribute('role', 'listbox');

    var inputs = Array.from(config.fieldset.querySelectorAll('input[type="radio"]'));

    inputs.forEach(function (input) {
      var label = config.fieldset.querySelector(
        'label[for="' + escapeSelector(input.id) + '"]'
      );
      var optionText = cleanText(label);

      if (isHiddenOption(config.rowKey, input.value)) {
        return;
      }

      var item = document.createElement('li');
      item.className = 'mida-set-menu__item';
      item.setAttribute('role', 'option');
      item.dataset.value = input.value;
      item.dataset.optionName = config.optionName;
      item.dataset.label = optionText;

      var itemLabel = document.createElement('span');
      itemLabel.className = 'mida-set-menu__label';
      itemLabel.textContent = optionText;

      var soldOutLabel = document.createElement('span');
      soldOutLabel.className = 'mida-set-menu__soldout';
      soldOutLabel.textContent = 'Ausverkauft';

      item.appendChild(itemLabel);
      item.appendChild(soldOutLabel);

      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var hadRowError = config.row.classList.contains('mida-set-row--error');

        labelSpan.textContent = optionText;
        trigger.dataset.midaUserPicked = 'true';
        trigger.dataset.value = input.value;
        trigger.classList.add('mida-set-select--selected');
        config.row.classList.add('mida-set-row--selected');

        menu.querySelectorAll('.mida-set-menu__item').forEach(function (i) {
          i.classList.remove('is-active');
        });
        item.classList.add('is-active');

        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');

        if (config.kind === 'color' || config.kind === 'scent') {
          setRowImage(
            config.row,
            getSelectedImage(config.rowKey, config.productHandle, input.value, config.genericImage)
          );
        }

        input.checked = true;
        resetDependentDropdowns(config.builder, config.optionName, trigger);
        setRowError(config.row, hadRowError && !rowSelectionsComplete(config.row));
        reconcileUnderlyingVariant(config.builder);
        dispatchVariantChange(config.builder, input);
        updateDropdownAvailability(config.builder);
      });

      menu.appendChild(item);
    });

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      updateDropdownAvailability(config.builder);

      var willOpen = !dropdown.classList.contains('is-open');
      closeAllDropdowns(dropdown);

      if (willOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    dropdown.appendChild(trigger);
    dropdown.appendChild(menu);

    return dropdown;
  }

  function makeSwatchSelectorFromFieldset(config) {
    var group = document.createElement('div');
    group.className = 'mida-set-swatch-group';
    group.dataset.midaUserPicked = 'false';
    group.dataset.optionName = config.optionName;
    group.dataset.rowKey = config.rowKey;
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', config.title || config.placeholder || 'Farbe');

    var inputs = Array.from(config.fieldset.querySelectorAll('input[type="radio"]'));

    inputs.forEach(function (input) {
      var label = config.fieldset.querySelector(
        'label[for="' + escapeSelector(input.id) + '"]'
      );
      var optionText = cleanText(label);
      var optionKey = getColorKey(input.value);

      if (isHiddenOption(config.rowKey, input.value)) {
        return;
      }

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mida-set-swatch';
      button.dataset.value = input.value;
      button.dataset.optionName = config.optionName;
      button.dataset.label = optionText;
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', 'false');
      button.setAttribute('aria-label', optionText);

      button.innerHTML =
        '<span class="mida-set-swatch__dot" style="--mida-swatch-color: ' + escapeHtml(getSwatchColor(input.value)) + '"></span>' +
        '<span class="mida-set-swatch__label">' + escapeHtml(optionText) + '</span>';

      if (optionKey === 'weiss') button.classList.add('mida-set-swatch--light');

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var hadRowError = config.row.classList.contains('mida-set-row--error');

        input.checked = true;
        group.dataset.midaUserPicked = 'true';
        group.dataset.value = input.value;
        config.row.classList.add('mida-set-row--selected');

        group.querySelectorAll('.mida-set-swatch').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-checked', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');

        if (config.rowKey === 'bedding-color') {
          updateBeddingSharedImages(config.builder, input.value);
        }

        setRowError(config.row, hadRowError && !rowSelectionsComplete(config.row));
        reconcileUnderlyingVariant(config.builder);
        dispatchVariantChange(config.builder);
        updateDropdownAvailability(config.builder);
      });

      group.appendChild(button);
    });

    return group;
  }

  function makeRow(config) {
    var row = document.createElement('div');
    row.className = 'mida-set-row';
    if (config.static) row.classList.add('mida-set-row--static');
    if (config.swatch) row.classList.add('mida-set-row--swatches', 'mida-set-row--shared-color');
    row.setAttribute('data-row', config.key);

    if (config.swatch) {
      row.innerHTML =
        '<div class="mida-set-body">' +
          '<div class="mida-set-title">' +
            '<strong>' + escapeHtml(config.title) + '</strong>' +
            '<span class="mida-set-error" hidden>Auswahl fehlt</span>' +
          '</div>' +
          '<p' + (config.subtitle ? '' : ' hidden') + '>' + escapeHtml(config.subtitle) + '</p>' +
          '<div class="mida-set-control"></div>' +
        '</div>';
    } else {
      row.innerHTML =
        '<div class="mida-set-img">' +
          '<img src="' + escapeHtml(config.image) + '" alt="' + escapeHtml(config.title) + '">' +
        '</div>' +
        '<div class="mida-set-body">' +
          '<div class="mida-set-title">' +
            '<strong>' + escapeHtml(config.title) + '</strong>' +
          '</div>' +
          '<p' + (config.subtitle ? '' : ' hidden') + '>' + escapeHtml(config.subtitle) + '</p>' +
          '<div class="mida-set-control"' + (config.static ? ' hidden' : '') + '></div>' +
          '<span class="mida-set-error" hidden>Auswahl fehlt</span>' +
        '</div>';
    }

    if (config.static) return row;

    var controls = config.controls || [config];
    var controlWrap = row.querySelector('.mida-set-control');

    if (config.swatch) {
      controlWrap.appendChild(
        makeSwatchSelectorFromFieldset({
          builder: config.builder,
          fieldset: config.fieldset,
          placeholder: config.placeholder,
          rowKey: config.key,
          row: row,
          optionName: config.optionName,
          title: config.title
        })
      );

      return row;
    }

    controls.forEach(function (control) {
      controlWrap.appendChild(
        makeDropdownFromFieldset({
          builder: config.builder,
          fieldset: control.fieldset,
          placeholder: control.placeholder,
          rowKey: control.rowKey || config.key,
          kind: control.kind,
          row: row,
          optionName: control.optionName,
          productHandle: config.productHandle,
          genericImage: config.image
        })
      );
    });

    return row;
  }

  function bindCartValidation(builder, variantSelects) {
    if (!variantSelects && !builder.midaComponentSet) return;

    var buyWrapper = getBuyWrapper(variantSelects);
    var submitButton = buyWrapper && buyWrapper.querySelector('[type="submit"], button[name="add"]');
    var form =
      (buyWrapper && buyWrapper.closest('form')) ||
      getScope(variantSelects).querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (submitButton && !submitButton.dataset.midaValidationBound) {
      submitButton.dataset.midaValidationBound = 'true';

      submitButton.addEventListener(
        'click',
        function (event) {
          if (validateSelections(builder, true)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var firstError = builder.querySelector('.mida-set-select--error, .mida-set-swatch-group--error .mida-set-swatch');
          if (firstError) firstError.focus();
        },
        true
      );
    }

    if (form && !form.dataset.midaValidationBound) {
      form.dataset.midaValidationBound = 'true';

      form.addEventListener(
        'submit',
        function (event) {
          if (validateSelections(builder, true)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var firstError = builder.querySelector('.mida-set-select--error, .mida-set-swatch-group--error .mida-set-swatch');
          if (firstError) firstError.focus();
        },
        true
      );
    }
  }

  function getVisibleFieldsets(variantSelects) {
    if (!variantSelects) return [];

    return Array.from(variantSelects.querySelectorAll('fieldset.product-form__input'))
      .filter(function (fieldset) {
        return !fieldset.classList.contains('hidden') || fieldset.querySelectorAll('input[type="radio"]').length > 1;
      });
  }

  function fieldsetInfo(fieldset, productHandle, index) {
    var optionName = getOptionName(fieldset);
    var legendText = cleanText(fieldset.querySelector('legend'));
    var name = optionName || legendText;
    var key = getRowKey(name, productHandle);
    var kind = getOptionKind(name);

    return {
      fieldset: fieldset,
      optionName: optionName,
      key: key,
      kind: kind,
      title: stripOptionHint(name),
      subtitle: SUBTITLES[key] || '',
      placeholder: getPlaceholder(kind),
      rowKey: key,
      originalIndex: index
    };
  }

  function findInfoByKey(infos, key) {
    return infos.find(function (info) {
      return info.key === key;
    });
  }

  function findInfoByKind(infos, kind) {
    return infos.find(function (info) {
      return info.kind === kind;
    });
  }

  function staticRow(config) {
    return {
      key: config.key,
      title: config.title,
      subtitle: SUBTITLES[config.key] || config.subtitle || '',
      image: config.image,
      productHandle: config.productHandle,
      static: true,
      originalIndex: config.originalIndex || -1
    };
  }

  function getRowTitle(info) {
    if (!info) return '';
    if (info.key === 'home-pillow') return 'HOME Nackenkissen';
    if (info.key === 'home-duvet') return 'HOME Bettdecke';
    if (info.key === 'bedding-duvet-cover') return 'HOME Premium Bettdeckenbezug';
    if (info.key === 'bedding-pillowcase' || info.key === 'cotton-cover') return 'HOME Premium Kissenbezug';
    if (info.key === 'silk-pillowcase') return 'HOME Seidenkissenbezug';
    if (info.key === 'silk-mask') return 'Seidenschlafmaske';
    if (info.key === 'seat-cushion') return 'Ergonomisches Sitzkissen';
    if (info.key === 'seat-cushion-cover') return 'Ergonomisches Rückenstützkissen';

    return info.title || info.optionName;
  }

  function getSpecialRows(variantSelects, productHandle, fallbackImage) {
    var handle = normalize(productHandle);
    var infos = getVisibleFieldsets(variantSelects).map(function (fieldset, index) {
      return fieldsetInfo(fieldset, productHandle, index);
    });

    if (handle === 'bettwaesche-set-baumwolle') {
      var pillowSize = findInfoByKey(infos, 'bedding-pillowcase');
      var duvetSize = findInfoByKey(infos, 'bedding-duvet-cover');
      var color = findInfoByKind(infos, 'color');
      var rows = [];

      if (pillowSize) {
        rows.push({
          key: 'bedding-pillowcase',
          title: getRowTitle(pillowSize),
          subtitle: SUBTITLES['bedding-pillowcase'],
          image: getGenericImage('bedding-pillowcase', productHandle, fallbackImage),
          productHandle: productHandle,
          controls: [pillowSize],
          originalIndex: 0
        });
      }

      if (duvetSize) {
        rows.push({
          key: 'bedding-duvet-cover',
          title: getRowTitle(duvetSize),
          subtitle: SUBTITLES['bedding-duvet-cover'],
          image: getGenericImage('bedding-duvet-cover', productHandle, fallbackImage),
          productHandle: productHandle,
          controls: [duvetSize],
          originalIndex: 1
        });
      }

      if (color) {
        rows.push({
          key: 'bedding-color',
          title: 'Farbe (Set):',
          subtitle: '',
          fieldset: color.fieldset,
          optionName: color.optionName,
          placeholder: 'Farbe auswählen',
          productHandle: productHandle,
          swatch: true,
          originalIndex: 2
        });
      }

      return rows;
    }

    if (handle === 'home-seide-set') {
      var silkColor = findInfoByKey(infos, 'silk-pillowcase') || infos[0];
      var silkSize = findInfoByKind(infos, 'size');
      var maskColor = findInfoByKey(infos, 'silk-mask');
      var silkRows = [];

      if (silkColor) {
        var silkControls = [silkColor];

        if (silkSize) {
          silkControls.push(silkSize);
        }

        silkRows.push({
          key: 'silk-pillowcase',
          title: getRowTitle(silkColor),
          subtitle: SUBTITLES['silk-pillowcase'],
          image: getGenericImage('silk-pillowcase', productHandle, fallbackImage),
          productHandle: productHandle,
          controls: silkControls,
          originalIndex: 0
        });
      }

      if (maskColor) {
        silkRows.push({
          key: 'silk-mask',
          title: getRowTitle(maskColor),
          subtitle: SUBTITLES['silk-mask'],
          image: getGenericImage('silk-mask', productHandle, fallbackImage),
          productHandle: productHandle,
          controls: [maskColor],
          originalIndex: 1
        });
      }

      return silkRows;
    }

    if (handle === 'home-pro-spar-set') {
      return [
        staticRow({
          key: 'home-pro-pillow',
          title: 'HOME Pro Kopfkissen',
          image: getGenericImage('home-pro-pillow', productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: 0
        })
      ].concat(infos.map(function (info) {
        return {
          fieldset: info.fieldset,
          optionName: info.optionName,
          key: info.key,
          kind: info.kind,
          title: getRowTitle(info),
          subtitle: SUBTITLES[info.key] || '',
          placeholder: info.placeholder,
          image: getGenericImage(info.key, productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: info.originalIndex + 1
        };
      }));
    }

    if (handle === 'travel-reisekissen-set') {
      return [
        staticRow({
          key: 'travel-pillow',
          title: 'TRAVEL Reisekissen',
          image: getGenericImage('travel-pillow', productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: 0
        })
      ].concat(infos.map(function (info) {
        return {
          fieldset: info.fieldset,
          optionName: info.optionName,
          key: info.key,
          kind: info.kind,
          title: getRowTitle(info),
          subtitle: SUBTITLES[info.key] || '',
          placeholder: info.placeholder,
          image: getGenericImage(info.key, productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: info.originalIndex + 1
        };
      }));
    }

    if (handle === 'sitzkissen-set') {
      return [
        staticRow({
          key: 'seat-cushion',
          title: 'Ergonomisches Sitzkissen',
          image: getGenericImage('seat-cushion', productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: 0
        }),
        staticRow({
          key: 'seat-cushion-cover',
          title: 'Ergonomisches Rückenstützkissen',
          image: getGenericImage('seat-cushion-cover', productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: 1
        })
      ];
    }

    return null;
  }

  function getRows(variantSelects) {
    var product = getProductMeta(variantSelects);
    var productHandle = product.handle || getHandleFromUrl(product.url);
    var fallbackImage = product.featuredImage;
    var specialRows = getSpecialRows(variantSelects, productHandle, fallbackImage);

    if (specialRows) return specialRows;

    return getVisibleFieldsets(variantSelects)
      .map(function (fieldset, index) {
        var info = fieldsetInfo(fieldset, productHandle, index);

        return {
          fieldset: fieldset,
          optionName: info.optionName,
          key: info.key,
          kind: info.kind,
          title: getRowTitle(info),
          subtitle: SUBTITLES[info.key] || '',
          placeholder: getPlaceholder(info.kind),
          image: getGenericImage(info.key, productHandle, fallbackImage),
          productHandle: productHandle,
          originalIndex: index
        };
      })
      .sort(function (a, b) {
        var orderDiff = getRowSortValue(a) - getRowSortValue(b);
        return orderDiff || a.originalIndex - b.originalIndex;
      });
  }

  // Component sets (snippets/mida-component-set.liquid): each row is its own product, so the builder resolves
  // one variant per row and sends them as a line item property instead of picking one variant of the set.
  function componentOptionName(slot, optionName) {
    return slot.key + ':' + optionName;
  }

  function findComponentSlot(componentSet, key) {
    return componentSet.slots.find(function (slot) {
      return slot.key === key;
    });
  }

  function getComponentValues(componentSet, slot, picked) {
    var values = {};

    slot.options.forEach(function (optionName) {
      var key = componentOptionName(slot, optionName);
      if (Object.prototype.hasOwnProperty.call(picked, key)) values[optionName] = picked[key];
    });

    if (slot.match) {
      var leaderKey = slot.match.slot + ':' + slot.match.option;
      if (Object.prototype.hasOwnProperty.call(picked, leaderKey)) values[slot.match.option] = picked[leaderKey];
    }

    return values;
  }

  function componentVariantMatches(slot, variant, values) {
    return slot.options.every(function (optionName, index) {
      return !Object.prototype.hasOwnProperty.call(values, optionName) || variant.options[index] === values[optionName];
    });
  }

  function getAvailableComponentVariants(slot, values) {
    return slot.variants.filter(function (variant) {
      return variant.available === true && componentVariantMatches(slot, variant, values);
    });
  }

  function getComponentOptionStatus(builder, optionName, value) {
    var componentSet = builder.midaComponentSet;
    var separator = optionName.indexOf(':');
    var slot = findComponentSlot(componentSet, optionName.slice(0, separator));
    var name = optionName.slice(separator + 1);
    if (!slot) return 'available';

    var picked = getPickedValues(builder, optionName);
    picked[optionName] = value;

    var values = getComponentValues(componentSet, slot, picked);
    var matches = slot.variants.filter(function (variant) {
      return componentVariantMatches(slot, variant, values);
    });
    if (!matches.length) return 'unavailable';
    if (!getAvailableComponentVariants(slot, values).length) return 'soldout';

    // A size that the matching cover or case cannot be bought in would leave the set incomplete.
    var followerSoldOut = componentSet.slots.some(function (follower) {
      if (!follower.match || follower.match.slot !== slot.key || follower.match.option !== name) return false;
      return !getAvailableComponentVariants(follower, getComponentValues(componentSet, follower, picked)).length;
    });

    return followerSoldOut ? 'soldout' : 'available';
  }

  function isComponentOptionSoldOut(builder, optionName) {
    var separator = optionName.indexOf(':');
    var slot = findComponentSlot(builder.midaComponentSet, optionName.slice(0, separator));
    return !!slot && !slot.variants.some(function (variant) {
      return variant.available === true;
    });
  }

  function resetSoldOutComponentPicks(builder, changedTrigger) {
    builder.querySelectorAll(CONTROL_SELECTOR).forEach(function (trigger) {
      if (trigger === changedTrigger || trigger.dataset.midaUserPicked !== 'true') return;
      if (getOptionStatus(builder, trigger.dataset.optionName, trigger.dataset.value) === 'available') return;
      resetControl(trigger);
    });
  }

  function formatComponentMoney(cents, roundWhole) {
    var amount = roundWhole ? Math.round(cents / 100) : cents / 100;
    var text = amount % 1 === 0 ? String(amount) : amount.toFixed(2).replace('.', ',');
    return text.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '€';
  }

  function updateComponentPrice(componentSet, priceCents, compareCents) {
    var container = document.getElementById('price-' + componentSet.sectionId);
    if (!container) return;

    var price = container.querySelector('.price');
    if (price) {
      price.dataset.priceCents = priceCents;
      price.dataset.compareAtPriceCents = compareCents;
    }

    container.querySelectorAll('.price__sale .price-item--regular').forEach(function (el) {
      el.textContent = formatComponentMoney(compareCents, componentSet.roundDisplayPrice);
    });
    container.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(function (el) {
      el.textContent = formatComponentMoney(priceCents, componentSet.roundDisplayPrice);
    });
    container.querySelectorAll('[data-discount-controller-target="discount-perc"]').forEach(function (el) {
      el.textContent = compareCents ? Math.round((1 - priceCents / compareCents) * 100) : 0;
    });
  }

  function setComponentButtonState(builder, soldOut) {
    var buyWrapper = getBuyWrapper(null);
    var button = buyWrapper && buyWrapper.querySelector('button[name="add"]');
    var label = button && button.querySelector('span');
    if (!button) return;

    if (soldOut) {
      button.setAttribute('disabled', 'disabled');
      buyWrapper.classList.add('disabled');
      if (label && window.variantStrings) label.textContent = window.variantStrings.soldOut;
    } else if (button.hasAttribute('disabled') && builder.dataset.midaComponentSoldOut === 'true') {
      button.removeAttribute('disabled');
      buyWrapper.classList.remove('disabled');
      if (label && window.variantStrings) label.textContent = window.variantStrings.addToCart;
    }

    builder.dataset.midaComponentSoldOut = soldOut ? 'true' : 'false';
  }

  function syncComponentSet(builder) {
    var componentSet = builder.midaComponentSet;
    var picked = getPickedValues(builder);
    var selections = {};
    var totalCents = 0;
    var complete = true;
    var soldOut = false;

    componentSet.slots.forEach(function (slot) {
      var values = getComponentValues(componentSet, slot, picked);
      var candidates = getAvailableComponentVariants(slot, values);
      var row = builder.querySelector('.mida-set-row[data-component-slot="' + escapeSelector(slot.key) + '"]');
      var slotComplete = slot.options.every(function (optionName) {
        return Object.prototype.hasOwnProperty.call(values, optionName);
      });

      // If several allowed variants share a combination, the last one in stock is used.
      var variant = slotComplete ? candidates[candidates.length - 1] : null;

      if (variant) {
        selections[slot.key] = variant.id;
        totalCents += variant.price;
      } else {
        complete = false;
        if (slotComplete) soldOut = true;
        totalCents += candidates.length
          ? Math[componentSet.incompletePriceMode === 'max' ? 'max' : 'min'].apply(
              null,
              candidates.map(function (candidate) { return candidate.price; })
            )
          : 0;
      }

      if (row && slot.match) {
        var leader = findComponentSlot(componentSet, slot.match.slot);
        var note = row.querySelector('.mida-set-match');
        var size = values[slot.match.option];
        if (note) {
          note.textContent = size
            ? slot.match.option + ': ' + size + ' (wie ' + leader.label + ')'
            : slot.match.option + ' wie ' + leader.label;
        }
      }

      // Rows without a curated IMAGE_MAP entry show the picked colour's own variant image.
      var pickedColor = Object.keys(values).some(function (optionName) {
        return getOptionKind(optionName) === 'color';
      });
      if (row && row.dataset.variantImages === 'true' && pickedColor) {
        var withImage = candidates.find(function (candidate) { return candidate.image; });
        if (withImage) setRowImage(row, withImage.image);
      }
    });

    var priceCents = Math.round((totalCents * (100 - componentSet.discountPercentage)) / 100);
    updateComponentPrice(componentSet, priceCents, totalCents);
    componentSet.input.value = complete ? JSON.stringify(selections) : '';
    setComponentButtonState(builder, soldOut);
  }

  function makeComponentFieldset(slot, optionName) {
    var fieldset = document.createElement('fieldset');
    var index = slot.options.indexOf(optionName);
    var values = [];

    slot.variants.forEach(function (variant) {
      var value = variant.options[index];
      if (values.indexOf(value) === -1) values.push(value);
    });

    values.forEach(function (value, valueIndex) {
      var id = 'mida-component-' + slot.key + '-' + index + '-' + valueIndex;
      var input = document.createElement('input');
      input.type = 'radio';
      input.id = id;
      input.name = componentOptionName(slot, optionName);
      input.value = value;

      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.textContent = value;

      fieldset.appendChild(input);
      fieldset.appendChild(label);
    });

    return fieldset;
  }

  function initComponentSetBuilder(dataNode) {
    var builderId = 'mida-components-' + dataNode.dataset.section;
    if (document.querySelector('.mida-set-builder[data-variant-selects-id="' + escapeSelector(builderId) + '"]')) return;

    var componentSet;
    try {
      componentSet = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }

    var input = dataNode.parentNode.querySelector('[data-mida-component-input]');
    var buyWrapper = getBuyWrapper(null);
    if (!componentSet || !componentSet.slots || !componentSet.slots.length || !input || !buyWrapper) return;

    componentSet.sectionId = dataNode.dataset.section;
    componentSet.input = input;

    var builder = document.createElement('div');
    builder.className = 'mida-set-builder';
    builder.dataset.variantSelectsId = builderId;
    builder.midaComponentSet = componentSet;

    var heading = document.createElement('h2');
    heading.textContent = SET_HEADING;
    builder.appendChild(heading);

    componentSet.slots.forEach(function (slot) {
      var rowKey = getRowKey(slot.label, slot.productHandle);
      var controls = slot.options
        .filter(function (optionName) {
          return !slot.match || optionName !== slot.match.option;
        })
        .map(function (optionName) {
          var kind = getOptionKind(optionName);
          return {
            fieldset: makeComponentFieldset(slot, optionName),
            optionName: componentOptionName(slot, optionName),
            kind: kind,
            placeholder: getPlaceholder(kind),
            rowKey: rowKey
          };
        });

      var image = getGenericImage(rowKey, slot.productHandle, slot.image);
      var row = makeRow({
        builder: builder,
        key: rowKey,
        title: slot.label,
        subtitle: SUBTITLES[rowKey] || '',
        image: image,
        productHandle: slot.productHandle,
        controls: controls
      });
      row.dataset.componentSlot = slot.key;
      row.dataset.variantImages = image === slot.image ? 'true' : 'false';

      if (slot.match) {
        var note = document.createElement('p');
        note.className = 'mida-set-match';
        row.querySelector('.mida-set-control').after(note);
      }

      builder.appendChild(row);
    });

    dataNode.parentNode.insertBefore(builder, dataNode);
    buyWrapper.classList.add('mida-set-buy-wrapper');

    clearAllErrors(builder);
    updateDropdownAvailability(builder);
    bindCartValidation(builder, null);
  }

  function initSetBuilder(variantSelects) {
    var buyWrapper = getBuyWrapper(variantSelects);
    var product = getProductMeta(variantSelects);
    var builderId = variantSelects ? variantSelects.id : 'mida-static-' + normalize(product.handle);

    if (!variantSelects || !buyWrapper || !isSetProduct(variantSelects)) return;

    getState(variantSelects);

    var existingBuilder = getScope(variantSelects).querySelector(
      '.mida-set-builder[data-variant-selects-id="' + builderId + '"]'
    );

    if (existingBuilder) {
      updateDropdownAvailability(existingBuilder);
      scheduleInitialVariantSync(existingBuilder);
      bindCartValidation(existingBuilder, variantSelects);
      return;
    }

    var rows = getRows(variantSelects);
    if (!rows.length) return;

    var builder = document.createElement('div');
    builder.className = 'mida-set-builder';
    builder.dataset.variantSelectsId = builderId;

    var heading = document.createElement('h2');
    heading.textContent = SET_HEADING;
    builder.appendChild(heading);

    rows.forEach(function (rowConfig) {
      rowConfig.builder = builder;
      builder.appendChild(makeRow(rowConfig));
    });

    variantSelects.parentNode.insertBefore(builder, variantSelects);

    variantSelects.classList.add('mida-original-variants');
    buyWrapper.classList.add('mida-set-buy-wrapper');

    clearAllErrors(builder);
    updateDropdownAvailability(builder);
    scheduleInitialVariantSync(builder);
    bindCartValidation(builder, variantSelects);
  }

  function initAllSetBuilders() {
    var componentSets = document.querySelectorAll('script[data-mida-component-set]');

    if (componentSets.length) {
      componentSets.forEach(initComponentSetBuilder);
      return;
    }

    var variantSelects = document.querySelectorAll('variant-selects');

    if (variantSelects.length) {
      variantSelects.forEach(initSetBuilder);
      return;
    }

    initStaticSetBuilder();
  }

  function initStaticSetBuilder() {
    if (!isSetProduct(null)) return;

    var product = getProductMeta(null);
    var builderId = 'mida-static-' + normalize(product.handle);
    var buyWrapper = getBuyWrapper(null);
    if (!buyWrapper) return;

    if (document.querySelector('.mida-set-builder[data-variant-selects-id="' + builderId + '"]')) {
      return;
    }

    var rows = getRows(null);
    if (!rows.length) return;

    var builder = document.createElement('div');
    builder.className = 'mida-set-builder';
    builder.dataset.variantSelectsId = builderId;

    var heading = document.createElement('h2');
    heading.textContent = SET_HEADING;
    builder.appendChild(heading);

    rows.forEach(function (rowConfig) {
      rowConfig.builder = builder;
      builder.appendChild(makeRow(rowConfig));
    });

    buyWrapper.parentNode.insertBefore(builder, buyWrapper);
    buyWrapper.classList.add('mida-set-buy-wrapper');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mida-set-dropdown')) {
      closeAllDropdowns(null);
    }
  });

  initAllSetBuilders();

  new MutationObserver(initAllSetBuilders).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
